import { render, staticRenderFns } from "./CourseCompleteListPage.vue?vue&type=template&id=64e9bc33"
import script from "./CourseCompleteListPage.vue?vue&type=script&lang=js"
export * from "./CourseCompleteListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports